import React from 'react'
import {
  CheckCircle as CheckCircleIcon,
  AlertCircle as AlertCircleIcon,
  TrendingUp as TrendingUpIcon,
  Award as AwardIcon,
} from 'react-feather'
import { Box, Paper, Tab, Tabs, Typography } from '@material-ui/core'

import useStyles from './styles'

const SuppliersQuestionnairesTabHeader = ({
  questionnaire = {},
  onTabChange = () => {},
  currentTab = 'answered',
}) => {
  const classes = useStyles()

  const answeredCount = questionnaire?.answeredCount || 0
  const pendingCount = (questionnaire?.totalCount || 0) - answeredCount
  const progressPercentage = questionnaire?.answerPercentage || 0
  const complianceGap = parseFloat(questionnaire?.conformityPercentage || 0)

  const statsCards = [
    {
      id: 'progress',
      label: 'Progresso de Resolução',
      value: `${progressPercentage.toFixed(0)}%`,
      icon: TrendingUpIcon,
      bgClass: classes.progressBg,
      iconClass: classes.progressIcon,
    },
    {
      id: 'answered',
      label: 'Respondidas',
      value: answeredCount,
      icon: CheckCircleIcon,
      bgClass: classes.answeredBg,
      iconClass: classes.answeredIcon,
    },
    {
      id: 'pending',
      label: 'Pendentes',
      value: pendingCount,
      icon: AlertCircleIcon,
      bgClass: classes.pendingBg,
      iconClass: classes.pendingIcon,
    },
    {
      id: 'compliance',
      label: 'Conformidade',
      value: `${complianceGap.toLocaleString()}%`,
      icon: AwardIcon,
      bgClass: classes.complianceBg,
      iconClass: classes.complianceIcon,
    },
  ]

  const tabs = [
    {
      value: 'todos',
      label: 'Todos',
      Icon: TrendingUpIcon,
    },
    {
      value: 'pending',
      label: 'Pendentes',
      Icon: AlertCircleIcon,
    },
    {
      value: 'answered',
      label: 'Respondidas',
      Icon: CheckCircleIcon,
    },
  ]

  return (
    <Box>
      <Box className={classes.statsContainer}>
        {statsCards.map((stat) => {
          const Icon = stat.icon
          return (
            <Paper
              key={stat.id}
              variant="outlined"
              className={classes.statsCard}
            >
              <Box className={classes.statsCardInner}>
                <Box className={`${classes.statsIconBox} ${stat.bgClass}`}>
                  <Icon size={24} className={stat.iconClass} />
                </Box>
                <Box className={classes.statsContent}>
                  <Typography className={classes.statsValue}>
                    {stat.value}
                  </Typography>
                  <Typography className={classes.statsLabel}>
                    {stat.label}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          )
        })}
      </Box>

      <Box width="100%">
        <Tabs
          onChange={(event, value) => onTabChange(value)}
          scrollButtons="auto"
          value={currentTab}
          variant="scrollable"
          textColor="primary"
        >
          {tabs.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
      </Box>
    </Box>
  )
}

export default SuppliersQuestionnairesTabHeader
